import { graphql } from 'gql';

export const bimWorkOrderVersionSeasonsGql = graphql(`
    query bimWorkOrderVersionSeasons($workOrderVersionId: Long!) {
        bimWorkOrderVersionSeasons(workOrderVersionId: $workOrderVersionId) {
            data {
                firstSeason {
                    workOrderVersionId
                    id
                    year
                }
                lastSeason {
                    workOrderVersionId
                    id
                    year
                }
            }
        }
    }
`);

export const bimWorkOrderVersionConstructionTypesGql = graphql(`
    query bimWorkOrderVersionConstructionTypes($workOrderVersionId: Long!) {
        bimWorkOrderVersionConstructionTypes(workOrderVersionId: $workOrderVersionId) {
            data {
                name
                id
                catalogId
                fullName
            }
        }
    }
`);
